export default "__VITE_ASSET__B_OPG_to__"